const SendArrow = ({ color = 'currentColor' }: { color?: string }) => {
  return (
    <svg
      width="22"
      height="23"
      viewBox="0 0 22 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          d="M1.69775 11.3023L11.0001 2L20.3024 11.3023"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          d="M11 22L11 3.39535"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
        />
      </g>
    </svg>
  );
};

export default SendArrow;
